import { DataProviderKey, IGetListParams } from "../../../types/reactAdmin.types";
import { AppResource } from "../../../types/resource.types";
import { getFinalList } from "../../../utils/collectionQuery";
import { firestore } from "../../firebase";

const adminAcademyReviewsResource = {
  [AppResource.adminAcademyReviews]: {
    [DataProviderKey.getList]: async (params: IGetListParams) => {
      return getFinalList(
        {
          ...params,
          limit: params.pagination.perPage,
        },
        firestore.collectionGroup(AppResource.academyReviews)
      );
    },
  },
};

export default adminAcademyReviewsResource;
